/**
 * Unified syntax highlighting style for JSON/code viewers.
 * Used by WorkflowJsonView and NodeExecutionDetails components.
 */
export function getSyntaxHighlightingStyle(isDark: boolean) {
  // Base token style to reset backgrounds and shadows
  const tokenBase = {
    background: "transparent",
    textShadow: "none",
  };

  return {
    'code[class*="language-"]': {
      color: isDark ? "#cdd6f4" : "#24292e",
      fontFamily: '"Fira Code", "Fira Mono", Consolas, Monaco, "Courier New", monospace',
      background: "transparent",
      textShadow: "none",
    },
    'pre[class*="language-"]': {
      color: isDark ? "#cdd6f4" : "#24292e",
      fontFamily: '"Fira Code", "Fira Mono", Consolas, Monaco, "Courier New", monospace',
      background: "transparent",
      textShadow: "none",
    },
    comment: { ...tokenBase, color: isDark ? "#6c7086" : "#6a737d" },
    prolog: { ...tokenBase, color: isDark ? "#6c7086" : "#6a737d" },
    doctype: { ...tokenBase, color: isDark ? "#6c7086" : "#6a737d" },
    cdata: { ...tokenBase, color: isDark ? "#6c7086" : "#6a737d" },
    punctuation: { ...tokenBase, color: isDark ? "#bac2de" : "#24292e" },
    property: { ...tokenBase, color: isDark ? "#fab387" : "#005cc5" },
    tag: { ...tokenBase, color: isDark ? "#fab387" : "#005cc5" },
    boolean: { ...tokenBase, color: isDark ? "#fab387" : "#005cc5" },
    number: { ...tokenBase, color: isDark ? "#fab387" : "#005cc5" },
    constant: { ...tokenBase, color: isDark ? "#fab387" : "#005cc5" },
    symbol: { ...tokenBase, color: isDark ? "#fab387" : "#005cc5" },
    deleted: { ...tokenBase, color: isDark ? "#f38ba8" : "#d73a49" },
    selector: { ...tokenBase, color: isDark ? "#a6e3a1" : "#22863a" },
    "attr-name": { ...tokenBase, color: isDark ? "#a6e3a1" : "#22863a" },
    string: { ...tokenBase, color: isDark ? "#a6e3a1" : "#22863a" },
    char: { ...tokenBase, color: isDark ? "#a6e3a1" : "#22863a" },
    builtin: { ...tokenBase, color: isDark ? "#a6e3a1" : "#22863a" },
    inserted: { ...tokenBase, color: isDark ? "#a6e3a1" : "#22863a" },
    operator: { ...tokenBase, color: isDark ? "#89dceb" : "#d73a49" },
    entity: { ...tokenBase, color: isDark ? "#89dceb" : "#d73a49" },
    url: { ...tokenBase, color: isDark ? "#89dceb" : "#d73a49" },
    ".language-css .token.string": { ...tokenBase, color: isDark ? "#a6e3a1" : "#22863a" },
    ".style .token.string": { ...tokenBase, color: isDark ? "#a6e3a1" : "#22863a" },
    atrule: { ...tokenBase, color: isDark ? "#cba6f7" : "#d73a49" },
    "attr-value": { ...tokenBase, color: isDark ? "#a6e3a1" : "#22863a" },
    keyword: { ...tokenBase, color: isDark ? "#cba6f7" : "#d73a49" },
    function: { ...tokenBase, color: isDark ? "#89b4fa" : "#6f42c1" },
    "class-name": { ...tokenBase, color: isDark ? "#89b4fa" : "#6f42c1" },
  };
}
